import { gql } from '@apollo/client';
import { ChargerGroupForExtend, ChargersWithMeta, PlanTariffForExtend, TariffForExtend } from './fragments';

export const createPlanTariffsForExtend = gql`
  mutation createPlanTariffsForExtend($input: CreatePlanTariffsInput!) {
    createPlanTariffs(input: $input) {
      ...ChargerGroupForExtend
      tariff {
        ...TariffForExtend
      }
      planTariffs {
        ...PlanTariffForExtend
      }
      chargers {
        ...ChargersWithMeta
      }
    }
  }
  ${ChargerGroupForExtend}
  ${TariffForExtend}
  ${PlanTariffForExtend}
  ${ChargersWithMeta}
`;
